import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box, useTheme, Typography, Checkbox, Button } from "@mui/material";
import { tokens } from "../../theme";
import { useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faCheckCircle, faTimesCircle, faCheckDouble, faTrash } from "@fortawesome/free-solid-svg-icons";

import CustomToolbar from "./custom-toolbar";

import IconButton from '@mui/material/IconButton';
import Swal from "sweetalert2";


import { updatedTransaction, toggleFirestoreValue } from '../../utils/firebase/firebase.datatable'

import { selectSellers } from '../../store/sellers/sellers.selector'

import { useSelector } from "react-redux";

import { Link } from 'react-router-dom';

import toast from "react-hot-toast";

const parseDateOnlyAsLocal = (value) => {
	if (!value) return null;

	// Se vier "YYYY-MM-DD", parse como data local (sem UTC)
	if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
		const [y, m, d] = value.split("-").map(Number);
		return new Date(y, m - 1, d);
	}

	// fallback (se vier com hora/timezone, etc.)
	const dt = new Date(value);
	return Number.isNaN(dt.getTime()) ? null : dt;
};

const formatDateBR = (date) =>
	date
		? date.toLocaleDateString("pt-BR")
		: "-";


const AdminTable = ({ transactions }) => {
	console.log('transaction', transactions[0])
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);

	const receivedArr = ['Pago', 'Confirmado', 'Recebido']

	const sellers = useSelector(selectSellers);

	const getKitPayDatesFromRow = (row) => {
		if (!Array.isArray(row.prodctsSell)) return "-";

		const dates = row.prodctsSell
			.filter((item) => item && item.kit__pay_date)
			.map((item) => item.kit__pay_date);

		if (!dates.length) return "-";

		const uniqueDates = [...new Set(dates)];

		return uniqueDates
			.map((d) => formatDateBR(parseDateOnlyAsLocal(d)))
			.join(" / ");
	};

	const handlerProd = (prod) => {
		if (typeof prod === 'string') {
			return prod
		}
		if (prod?.length > 0 && typeof prod[0] === 'string') {
			return prod.join(" - ")
		}

		if (Array.isArray(prod)) {
			if (!prod[0]['descricao']) {
				const onlyProds = prod.map((prods) => prods.product_id_produto)
				return onlyProds.join(" - ")
			}
			const onlyProds = prod.slice(1).map((prods) => prods.product_id_produto)
			return onlyProds.join(" - ")
		}
		if (prod?.length > 0) {
			return prod.join(" - ")
		}

		return prod
	}
	const handlerEditTransaction = (data) => {
		console.log("transaction", data)
		const { count, ...rest } = data
		const objToAdd = {
			...rest,
			status: 'cancelado'
		}
		Swal.fire({
			title: "Atenção!!",
			html: `Deseja cancelar a transação <b>${data.id}</b> ??`,
			icon: "question",
			showCancelButton: true, // Add cancel button
			backdrop: 'static', // Make sure modal doesn't close on click outside
			confirmButtonText: 'Confirmar', // Set text for confirm button
			cancelButtonText: 'Cancelar', // Set text for cancel button
			showDenyButton: false, // Hide deny button
			reverseButtons: true, // Place cancel button on the left
			allowOutsideClick: false, // Prevent closing by clicking outside
			allowEscapeKey: false, // Prevent closing by pressing Escape
			preConfirm: async () => {
				// Perform your logic here if you want to do something when the confirm button is clicked.
				const newDoc = await (updatedTransaction(data.id, objToAdd))
				console.log('newDoc', newDoc)
			}
		});
	}

	const copyToClipboard = (params) => {
		console.log(params.row)
		const paramsString = JSON.stringify(params.row, null, 2);
		navigator.clipboard.writeText(paramsString)
			.then(() => {
				toast.success(
					`Dados copiados !!`,
					{
						position: 'top-right'
					}
				);
			})
			.catch(err => console.error("Failed to copy:", err));
	};



	const columns = [
		{
			field: "count",
			headerName: ".",
			flex: 0.2,
			renderHeader: params =>
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<ArrowDropDownIcon color="success" />
				</Box>
		},
		// { field: "sellerId", headerName: "ID Vendedor", flex: 1 },
		{
			field: "dataCreated",
			headerName: "Data",
			flex: 1,
			renderCell: params =>
				<Typography color={colors.greenAccent[400]}>
					{params.row.dataCreated}
				</Typography>
		},
		{
			field: "sellerName",
			headerName: "Vendedor",
			flex: 1,
			cellClassName: "name-column--cell",
			renderCell: (params) => {
				const sellerEmail = params.row.sellerMail; // Assuming your rows have an `email` field
				const seller = sellers.find((s) => s.email === sellerEmail);
				if (!seller) {
					return <span>{params.value}</span>; // Fallback if seller not found
				}
				const truncatedName = params.value.length > 20 ? params.value.slice(0, 20) + '...' : params.value;

				return (
					<Button
						component={Link}
						to={`/vendedoras/${seller.slug}`}
						state={{ sellerData: seller }}
						variant="contained" // Or "outlined", "contained" as needed
						sx={{
							textTransform: 'none',
							textDecoration: 'none',
							backgroundColor: colors.pink[600],
							color: 'white', // Custom text color
							'&:hover': {
								backgroundColor: colors.pink[800]
							},
						}}
					>
						{truncatedName}
					</Button>
				);
			},
		},
		{
			field: "quantityPayment",
			headerName: "Parcelas",
			type: "number",
			headerAlign: "left",
			align: "left",
			flex: 0.5
		},
		{
			field: "type",
			headerName: "Operação",
			flex: 0.9,
			renderCell: params =>
				<Typography
					className={params.row.type === "pix" ? "pix" : "credito"}
					onClick={() => copyToClipboard(params)}
					sx={{ cursor: 'pointer' }}
				>
					{params.row.type}
				</Typography>
		},
		{ field: "clientMail", headerName: "E-mail Cliente", flex: 1.5 },
		{ field: "sellerMail", headerName: "E-mail Vendedor", flex: 1.5 },
		{
			field: "prodctsSell", headerName: "Produtos", flex: 2,
			renderCell: params => {
				return (
					<Typography
					>
						{
							handlerProd(params.row.prodctsSell)
						}
					</Typography>
				)
			}

		},
		{
			field: "value",
			headerName: "Valor",
			flex: 0.6,
			renderCell: params =>
				<Typography color={colors.greenAccent[400]}>
					{parseFloat(params.row.value).toLocaleString("pt-br", {
						style: "currency",
						currency: "BRL"
					})}
				</Typography>
		},
		{
			field: "kitPayDate",
			headerName: "Vencimento Kit",
			flex: 1,
			valueGetter: (params) => getKitPayDatesFromRow(params.row),
			renderCell: (params) => (
				<Typography color={colors.blueAccent[300]}>
					{params.value}
				</Typography>
			),
		},
		{
			field: "checked",
			headerName: "Conferência",
			flex: 0.6,
			renderCell: params => (
				<Checkbox
					checked={params.row.checked} // Replace with the appropriate field
					onChange={() => toggleFirestoreValue(params.row.id, params.row.checked)} // Ensure `id` is correctly set in your data
					color="success"
				/>
			)
		},
		{
			field: "pagamento",
			headerName: "Status",
			flex: 1,
			renderCell: params =>
				<Typography
					color={colors.greenAccent[400]}
					sx={{ cursor: "pointer" }}
					onClick={() =>
						console.log('click here ', params)
					}
				>	{
						params.row.pagamento !== " - " &&
						<FontAwesomeIcon
							icon={receivedArr.includes(params.row.pagamento) ? faCheckDouble : faTimesCircle}
							color={receivedArr.includes(params.row.pagamento) ? colors.greenAccent[300] : colors.redAccent[300]}
							size="sm"
							style={{ marginLeft: "10px", paddingLeft: '10px' }}
						/>
					}
					<span style={{ marginLeft: '10px', color: receivedArr.includes(params.row.pagamento) ? colors.greenAccent[300] : colors.redAccent[300] }}>{params.row.pagamento}</span>
				</Typography>
		},
		{
			field: "idAsaas",
			headerName: "Id Asaas",
			flex: 1,
			hide: true,
			renderCell: params =>
				<Typography
					sx={{ cursor: "pointer" }}
					onClick={() =>
						console.log('click here ', params)
					}
				>
					<span style={{ marginLeft: '10px' }}>{params.row.idAsaas}</span>
				</Typography>
		},
		{
			field: "appVersion",
			headerName: "Dispositivo",
			hide: true,
			flex: 1,
			renderCell: params => {
				return (
					<Typography
					>
						{
							params.row.appVersion
						}
					</Typography>
				)
			}

		},
		{
			field: "action",
			headerName: "Remover",
			flex: 0.4,
			renderCell: params =>
				<IconButton aria-label="deactivate" onClick={() =>
					handlerEditTransaction(params.row)
				}
					sx={{ cursor: "pointer" }}
				>
					<FontAwesomeIcon
						icon={faTrash}
						color={colors.redAccent[600]}
						size="sm"

					/>
				</IconButton>
		},
	];

	return (
		<Box
			sx={{
				width: "100%",
				minHeight: "600px",
				height: "100%",
				margin: "10px",
				padding: "10px",
				whiteSpace: "nowrap",
				marginTop: '0px',
				paddingTop: '0px'
			}}
		>
			<Typography variant="h3" color={colors.blueAccent[400]} fontWeight={"bold"}>
				Operações
			</Typography>
			<Box
				m="10px 0 0 0"
				height="95%"
				sx={{
					"& .MuiDataGrid-root": {
						border: "none"
					},
					"& .MuiDataGrid-cell": {
						// borderBottom: "none"
					},
					"& .name-column--cell": {
						color: colors.pink[300]
					},
					"& .MuiDataGrid-columnHeaders": {
						backgroundColor: colors.blueAccent[700],
						borderBottom: "none"
					},
					"& .MuiDataGrid-virtualScroller": {
						backgroundColor: colors.primary[400]
					},
					"& .MuiDataGrid-footerContainer": {
						borderTop: "none",
						backgroundColor: colors.blueAccent[700]
					},
					"& .MuiDataGrid-toolbarContainer .MuiButton-text": {
						color: `${colors.grey[100]} !important`
					},
					"& .pix": {
						color: `${colors.blueAccent[300]} !important`
					},
					"& .credito": {
						color: `${colors.greenAccent[400]} !important`
					},
					zIndex: '1200'
				}}
			>
				<DataGrid
					rows={transactions}
					columns={columns}
					components={{ Toolbar: CustomToolbar }}
					componentsProps={{ toolbar: { title: 'Vendas' } }}
				/>
			</Box>
		</Box>
	);
};

export default AdminTable;
